var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 15.0968C20.88 15.0968 21.99 13.9768 21.99 12.5968C21.99 11.2168 20.88 10.0968 19.5 10.0968C18.12 10.0968 17 11.2168 17 12.5968C17 13.9768 18.12 15.0968 19.5 15.0968ZM12 14.0968C13.66 14.0968 14.99 12.7568 14.99 11.0968C14.99 9.4368 13.66 8.0968 12 8.0968C10.34 8.0968 9 9.4368 9 11.0968C9 12.7568 10.34 14.0968 12 14.0968ZM19.5 17.0968C17.67 17.0968 14 18.0168 14 19.8468V21.0968C14 21.6468 14.45 22.0968 15 22.0968H24C24.55 22.0968 25 21.6468 25 21.0968V19.8468C25 18.0168 21.33 17.0968 19.5 17.0968ZM12 16.0968C9.67 16.0968 5 17.2668 5 19.5968V21.0968C5 21.6468 5.45 22.0968 6 22.0968H12V19.8468C12 18.9968 12.33 17.5068 14.37 16.3768C13.5 16.1968 12.66 16.0968 12 16.0968Z",
    fill: "#314380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact_info.6ae4a4e336daef6e0392e57985f0a0af.svg";
export { ForwardRef as ReactComponent };